<form class="filter" #formElement [formGroup]="form">
  <mat-form-field class="medium-width margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="dateFrom"
      [matDatepicker]="pickerFrom"
      placeholder="Fecha desde (Entrega)"
    />
    <mat-datepicker-toggle matSuffix [for]="pickerFrom"></mat-datepicker-toggle>
    <mat-datepicker #pickerFrom></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="medium-width margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="dateTo"
      [matDatepicker]="pickerTo"
      placeholder="Fecha hasta (Entrega)"
    />
    <mat-datepicker-toggle matSuffix [for]="pickerTo"></mat-datepicker-toggle>
    <mat-datepicker #pickerTo></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="medium-width margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="appointmentDate"
      [matDatepicker]="pickerAppointmentDate"
      placeholder="Fecha turno"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="pickerAppointmentDate"
    ></mat-datepicker-toggle>
    <mat-datepicker #pickerAppointmentDate></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="medium-width margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="confirmDate"
      [matDatepicker]="pickerConfirmDate"
      placeholder="Fecha confirmación"
    />
    <mat-datepicker-toggle
      matSuffix
      [for]="pickerConfirmDate"
    ></mat-datepicker-toggle>
    <mat-datepicker #pickerConfirmDate></mat-datepicker>
  </mat-form-field>

  <mat-form-field class="medium-width margin-right-small">
    <input
      matInput
      autocomplete="off"
      formControlName="protocol"
      placeholder="Protocolo"
    />
  </mat-form-field>

  <mat-form-field class="medium-width">
    <input
      type="text"
      #referringPhysician
      matInput
      placeholder="Médico actuante"
      formControlName="studyReportPhysician"
      [matAutocomplete]="autReferringPhysician"
    />
    <mat-autocomplete
      #autReferringPhysician="matAutocomplete"
      [displayWith]="filterCompleteStudyReportPhysicians.displayFn"
    >
      <mat-option
        *ngFor="let physician of filteredStudyReportPhysiciansOptions | async"
        [value]="physician"
      >
        {{ physician.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width margin-right-small">
    <input
      type="text"
      matInput
      placeholder="Servicio"
      formControlName="service"
      [matAutocomplete]="autService"
    />
    <mat-autocomplete
      #autService="matAutocomplete"
      [displayWith]="filterCompleteServices.displayFn"
    >
      <mat-option
        *ngFor="let service of filteredServicesOptions | async"
        [value]="service"
      >
        {{ service.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width">
    <input
      type="text"
      matInput
      placeholder="Práctica región"
      formControlName="practiceRegion"
      [matAutocomplete]="autPractice"
    />
    <mat-autocomplete
      #autPractice="matAutocomplete"
      [displayWith]="filterCompletePractices.displayFn"
    >
      <mat-option
        *ngFor="let practice of filteredPracticesOptions | async"
        [value]="practice"
      >
        {{ practice.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-form-field class="medium-width margin-right-small">
    <input
      type="text"
      #referringPhysician
      matInput
      placeholder="Centro"
      formControlName="center"
      [matAutocomplete]="autCenter"
    />
    <mat-autocomplete
      #autCenter="matAutocomplete"
      [displayWith]="filterCompleteCenters.displayFn"
    >
      <mat-option
        *ngFor="let center of filteredCentersOptions | async"
        [value]="center"
      >
        {{ center.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <mat-form-field class="medium-width">
    <mat-select
      placeholder="Estados"
      formControlName="studyReportStates"
      multiple
    >
      <mat-select-trigger>
        {{
          f.studyReportStates.value?.length > 0
            ? f.studyReportStates.value[0].Name
            : ""
        }}
        <span
          *ngIf="f.studyReportStates.value?.length > 1"
          class="additional-selection"
        >
          (+{{ f.studyReportStates.value.length - 1 }}
          {{ f.studyReportStates.value?.length === 2 ? "otro" : "otros" }})
        </span>
      </mat-select-trigger>
      <mat-option
        *ngFor="let studyReportState of studyReportStates"
        [value]="studyReportState"
      >
        {{ studyReportState.Name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="medium-width">
    <mat-select placeholder="Entidades" formControlName="entities" multiple>
      <mat-select-trigger>
        {{ f.entities.value?.length > 0 ? f.entities.value[0].Name : "" }}
        <span *ngIf="f.entities.value?.length > 1" class="additional-selection">
          (+{{ f.entities.value.length - 1 }}
          {{ f.entities.value?.length === 2 ? "otra" : "otras" }})
        </span>
      </mat-select-trigger>

      <mat-option *ngFor="let entity of entities" (click)="toggleAllSelection(entity)" [value]="entity">
        {{ entity.Name }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <mat-form-field class="medium-width">
    <input
      type="text"
      #statusPhotography
      matInput
      placeholder="Estado fotografiado"
      formControlName="statusPhotography"
      [matAutocomplete]="autStatusPhotography"
    />
    <mat-autocomplete
      #autStatusPhotography="matAutocomplete"
      [displayWith]="filterCompleteStatusPhotography.displayFn"
    >
      <mat-option
        *ngFor="let item of filteredStatusPhotographyOptions | async"
        [value]="item"
      >
        {{ item.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>

  <div class="medium-full">
    <patient-autocomplete formControlName="patient"></patient-autocomplete>
  </div>

  <mat-form-field class="medium-width">
    <input
      type="text"
      #studyRegion
      matInput
      placeholder="Subespecialidad"
      formControlName="studyReportRegion"
      [matAutocomplete]="autStudyReportRegion"
    />
    <mat-autocomplete
      #autStudyReportRegion="matAutocomplete"
      [displayWith]="filterCompleteStudyRegion.displayFn"
    >
      <mat-option
        *ngFor="let item of filterCompleteStudyRegionOptions | async"
        [value]="item"
      >
        {{ item.Name }}
      </mat-option>
    </mat-autocomplete>
  </mat-form-field>
  <mat-checkbox class="margin-right-small" formControlName="onNoPublish"
    >No publicados</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="noReportPhysician"
    >Sin informante</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="withAdminControled"
    >Con ctrl. admin.</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="noAdminControled"
    >Sín ctrl. admin.</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="onlyEndAttention"
    >Solo fín de práctica</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="reAppointment"
    >Recitados</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="orderByDeliveryDate"
    >Ordenar por fecha entrega.</mat-checkbox
  >
  <mat-checkbox class="margin-right-small" formControlName="orderByConfirmDate"
    >Ordenar por fecha confirmación</mat-checkbox
  >
</form>
